import { useCallback, useEffect, useState } from 'react'
import * as yup from 'yup'
import { AnyObject } from 'yup'
import { api, ApiRoutes } from '../services/ApiService'

export const useUpdateData = <DataType extends object>(
    url: ApiRoutes,
    current: DataType,
    id: string | number,
    validation: AnyObject
) => {
    const [element, setElement] = useState<DataType>(current)
    const [files, setFiles] = useState<File[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isValid, setIsValid] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const changeProp = useCallback((data: Partial<DataType>) => {
        setElement((prevElement) => ({ ...prevElement, ...data }))
    }, [])

    const changeFile = (file: File) => {
        setFiles([file])
    }

    useEffect(() => {
        yup.object(validation)
            .validate(element)
            .then(() => {
                setError(null)
                setIsValid(true)
            })
            .catch((reason) => {
                setError(reason)
                setIsValid(false)
            })
    }, [element, validation])

    const submit = async () => {
        setIsLoading(true)

        const response = await api.post(url, id, element, files)
        setIsLoading(false)

        return response
    }

    return {
        error,
        element,
        isValid,
        isLoading,
        files,
        changeProp,
        changeFile,
        submit,
    }
}
